import { SET_MODAL_FACILITY } from 'store/types/facility';

const initialState = {
    modalFacility: {
        isOpen: false,
        isEdit: false,
        id: null,
    },
};

const facilityReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_MODAL_FACILITY:
            return {
                ...state,
                modalFacility: action?.payload,
            };
        default:
            return state;
    }
};

export default facilityReducer;